import type Order from '@/types/Order'
import type DataResponse from '@/types/DataResponse'
import type PaginatedResponse from '@/types/PaginatedResponse'
import type { AxiosResponse } from 'axios'
import { http } from '@/plugins/http'
import { useAdminStore } from '@/stores/admin'
import Sector from '@/types/Sector'

export interface StorePayload {
  event_id: string
  name: string
  user_id: string
  ticket_types: {
    id: string
    quantity: number
  }[]
}

export default class ComplimentaryTicketService {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Order>>> {
    return await http.get<PaginatedResponse<Order>>(`/api/v1/office/complimentary-tickets?page=${page}&${filters}&per_page=${per_page}`)
  }

  async store(model: StorePayload) {
    return await http.post<DataResponse<Order>>(`/api/v1/office/complimentary-tickets`, model)
  }

  async destroy(model: Order) {
    return await http.delete(`/api/v1/office/complimentary-tickets/${model.id}`)
  }

  async sectors(eventId: string) {
    return await http.get<DataResponse<Sector[]>>(`/api/v1/office/complimentary-tickets/events/${eventId}/sectors`)
  }

  print(model: Order) {
    const token = useAdminStore().token
    window.open(`${import.meta.env.VITE_API_URL}/api/v1/office/complimentary-tickets/${model.id}/print?access_token=${token}`, '_blank')
  }
}
